import React from "react";
import { Container, Table, Pagination } from "semantic-ui-react";
import _ from "lodash";
import * as ProfileTableColumns from "components/Admin/Profiles/ProfileTableColumns";
import { PendingRow } from "components/Admin/PendingRow";
import { PAGE_SIZE } from "env.config";

const ProfileRow = ({ host, columns, onSelect, isSelected }) => {
  return (
    <Table.Row active={isSelected} onClick={() => onSelect(host)}>
      {columns.map(({ render }, index) => (
        <Table.Cell key={index}>{render(host)}&nbsp;</Table.Cell>
      ))}
    </Table.Row>
  );
};

const ProfileHeaderRow = ({ columns }) => {
  return (
    <Table.Row>
      {columns.map(({ title, style }, index) => (
        <Table.HeaderCell key={index} style={style}>
          {title}&nbsp;
        </Table.HeaderCell>
      ))}
    </Table.Row>
  );
};

const ProfileTable = ({
  renderList,
  loaded,
  activePage,
  totalPages,
  selectedItem,
  onSelectItem,
  onChangePage,
}) => {
  const columns = [
    ProfileTableColumns.Platform,
    ProfileTableColumns.Scope,
    ProfileTableColumns.Stage,
    ProfileTableColumns.Host,
    ProfileTableColumns.ProfileName,
    ProfileTableColumns.Description,
    ProfileTableColumns.CreateDate,
  ];
  const tableRows = _.range(PAGE_SIZE).map((index) => {
    const host = renderList[index] || {};
    if (!loaded) {
      return <PendingRow columnCount={7} key={index} />;
    }
    return (
      <ProfileRow
        host={host}
        columns={columns}
        key={index}
        isSelected={
          selectedItem &&
          selectedItem.ProfileId &&
          host.ProfileId === selectedItem.ProfileId
        }
        onSelect={onSelectItem}
      />
    );
  });

  return (
    <Table className="ui celled table">
      <Table.Header>
        <ProfileHeaderRow columns={columns} />
      </Table.Header>
      <Table.Body>{tableRows}</Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell colSpan={7}>
            <Container fluid textAlign="right">
              <Pagination
                activePage={activePage + 1}
                onPageChange={onChangePage}
                totalPages={totalPages}
              />
            </Container>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export { ProfileTable };
